import FeedbackPopoverController from './vd-feedback-popover.controller'
import popoverTemplate from './vd-feedback-details.html'

const DEFAULT_THANK_YOU = 'Thank you for your feedback!'

/**
 * Controller for the vd-feedback component.
 */
export default class FeedbackController {
  constructor($log, vdFeedbackService, vdPopover) {
    'ngInject'
    this.$log = $log
    this.vdFeedbackService = vdFeedbackService
    this.vdPopover = vdPopover
  }

  $onInit() {
    this.score = 0
    this.requestFeedback = false
    this.shouldDisplayCompletion = false

    this.activity = this.activity || 'undefined-activity'
    this.forceUnseenActivitySample = this.forceUnseenActivitySample || false
    this.question = this.question || 'I thought that was'
    this.thankYouNote = DEFAULT_THANK_YOU

    // Hide the parent banner when we initialise if `hideBanner` has been set. Without this, when the activity has
    // already been responded to, the banner will be shown momentarily until the activity has been retrieved.
    if (this.vdBannerCtrl && this.hideBanner) {
      this.vdBannerCtrl.toggleBanner(false)
    }

    this.vdFeedbackService
      .registerActivity(this.activity, this.forceUnseenActivitySample)
      .then(({ requestSentiment }) => {
        this.requestFeedback = requestSentiment
        this._toggleBannerFeedback()

        if (requestSentiment) {
          // Send an event every time this vd-feedback is displayed
          this.vdFeedbackService.sentimentRequested({
            activity: this.activity,
          })
        }
      })
  }

  /**
   * Event handler invoked when the user has selected a score (1 / -1).
   *
   * @param {Event} $event
   * @param {number} score
   */
  scoreSelected($event, score) {
    this.score = score

    // Track the response
    this.vdFeedbackService
      .saveFeedback({
        activity: this.activity,
        score: this.score,
      })
      .then(() => {
        if (this.score > 0) {
          // no need to prompt for popover
          this._displayCompletionMessage()
        } else {
          this._showAdditionalFeedbackPopover($event.currentTarget)
        }
      })
      .catch(payload => this.$log.info(payload))
  }

  /**
   * Event handler invoked when the user has dismissed the feedback banner after responding.
   */
  dismissFeedback() {
    this.requestFeedback = false
    if (this.vdBannerCtrl) {
      this.vdBannerCtrl.toggleBanner(false)
    }
  }

  /**
   * Toggle display of the banner containing this feedback component based on whether the user has responded.
   *
   * @private
   */
  _toggleBannerFeedback() {
    if (this.vdBannerCtrl) {
      if (this.hideBanner) {
        this.vdBannerCtrl.toggleBanner(this.requestFeedback)
      }

      this.vdBannerCtrl.toggleFeedback(this.requestFeedback)
    }
  }

  /**
   * Show a popover requesting additional comments to give more context to negative feedback.
   *
   * @private
   * @param {Element} trigger
   */
  _showAdditionalFeedbackPopover(trigger) {
    this.vdPopover
      .open({
        trigger,
        template: popoverTemplate,
        controllerAs: '$ctrl',
        controller: FeedbackPopoverController,
        promptNegative: this.promptNegative,
        activity: this.activity,
        score: this.score,
      })
      .then(popover => popover.close)
      .then(() => this._displayCompletionMessage())
  }

  /**
   * Display a message in place of the feedback request once the user has responded.
   *
   * @private
   */
  _displayCompletionMessage() {
    if (this.score > 0) {
      this.thankYouNote = `Great! Glad that was ${this.promptPositive.toLowerCase()}.`
    } else {
      this.thankYouNote = DEFAULT_THANK_YOU
    }
    this.shouldDisplayCompletion = true
  }
}
